<div>
    <h2>NAD Report</h2>
  <form [formGroup]="NADForm">
    <div class="form-two-cols">
      <!-- Select Month -->
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Select Month</mat-label>
        <mat-select formControlName="selectedMonth">
          <mat-option *ngFor="let month of months || []" [value]="month.months_name">
            {{ month.months_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Select Year -->
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Select Year</mat-label>
        <mat-select formControlName="selectedYear">
          <mat-option *ngFor="let year of yearss || []" [value]="year.year_name">
            {{ year.year_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-two-cols">
      <!-- Select Course -->
      <mat-form-field class="w-100" appearance="fill">
        <mat-label>Select Course</mat-label>
        <mat-select formControlName="selectCourse">
          <mat-option *ngFor="let course of courseNames || []" [value]="course.id">
            {{ course.name }}-{{course.crs_code}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mb-4">
      <button mat-raised-button color="primary" (click)="getNADReport()">Display NAD Report</button>
    </div>
  </form>

  <!-- Table Section -->
  <div *ngIf="isCollegeList">
    <div class="sorting-table">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ displayedColumns.label[i] | uppercase }}
          </th>
          <td mat-cell *matCellDef="let row; let rowIndex = index">
            <ng-container [ngSwitch]="column">
              <ng-container *ngSwitchCase="'sno'">
                {{ currentPage + (rowIndex + 1) }}
              </ng-container>
              <ng-container *ngSwitchCase="'createdAt'">
                {{ row.createdAt | date: 'dd/MM/yyyy' }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ row[column] }}
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns.cols"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns.cols"></tr>
      </table>
    </div>
  </div>
</div>
